import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import * as React from 'react';
import { connect } from 'react-redux';
import RegisterComponent from '../components/register';
import { UserAuthenticationWrapper } from '../styles/login';
import { registerUser, getCountries, unmountRegisterState, verifyCaptcha } from '../actions/action.userAuth';
import LoaderComponent from 'src/components/common/loader.component';
import { push } from 'connected-react-router';
import { Carousel } from 'react-responsive-carousel';

class RegisterContainer extends React.Component<any, any> {
    state = {
        spacing: '16',
        message: ''
    };
    constructor(props: any) {
        super(props);

        this.registerUser = this.registerUser.bind(this);
        this.verifyCaptcha = this.verifyCaptcha.bind(this);
    }

    componentDidMount() {
        this.props.getCountries();
    }

    registerUser(data: any) {
        this.props.registerUser(data);
    }

    verifyCaptcha(captchaToken: any) {
        const LoginDto = {
            password: captchaToken
        };
        this.props.verifyCaptcha(LoginDto)
    }

    render() {
        return (
            <UserAuthenticationWrapper>
                <LoaderComponent sending={this.props.show} />
                <div className="backgroundLoginImage">
                    <div className="backgroundLoginLogo">
                        <Grid container={true} spacing={0}>
                            <Grid item={true} xs={12}>
                                <Grid container={true} justify="center" spacing={0}>

                                    <Grid item={true}>
                                        <Paper className="userForm" square={true}>
                                            <RegisterComponent
                                                registeredUser={this.props.registeredUser}
                                                countries={this.props.countries}
                                                registerUser={this.registerUser}
                                                redirect={this.props.redirectTo}
                                                unmountRegister={this.props.unmountRegisterState} 
                                                appSettings={this.props.appSettings}
                                                verifyCaptcha={this.verifyCaptcha}
                                                isCaptchaVerified={this.props.isCaptchaVerified} />
                                        </Paper>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>

                        <Carousel className="login-carousel" autoPlay={true} showThumbs={false} infiniteLoop={true} showIndicators={false} showStatus={false} showArrows={false}
                        interval={5000}>
                            {/* <div className="login-carousel-bg1" />                                                           */}
                            <div className="login-carousel-bg login-carousel-bg1" />                             
                            <div className="login-carousel-bg login-carousel-bg2" /> 
                            <div className="login-carousel-bg login-carousel-bg3" /> 
                            <div className="login-carousel-bg login-carousel-bg4" /> 
                            <div className="login-carousel-bg login-carousel-bg5" />                             
                            <div className="login-carousel-bg login-carousel-bg6" /> 
                            <div className="login-carousel-bg login-carousel-bg7" /> 
                            <div className="login-carousel-bg login-carousel-bg8" /> 
                        </Carousel>

                    </div>
                </div>
            </UserAuthenticationWrapper>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        show: state.common.show,
        countries: state.user.countries,
        registeredUser: state.userAuth.registeredUser,
        appSettings: state.userAuth.appSettings,
        isCaptchaVerified: state.userAuth.isCaptchaVerified
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        registerUser: (data: any) => dispatch(registerUser(data)),
        getCountries: () => dispatch(getCountries()),
        redirectTo: (path: string) => dispatch(push(path)),
        unmountRegisterState: () => dispatch(unmountRegisterState()),
        verifyCaptcha: (data: any) => dispatch(verifyCaptcha(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterContainer);



// WEBPACK FOOTER //
// ./src/containers/RegisterContainer.tsx